import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
// Models
import { sortElements, listDesc } from 'models/operator';
// Custom
import { operatorDataShape } from 'constants/PropTypesShapes';
import ResourceSelectFieldFilter from 'components/filters/ResourceSelectFieldFilter';

const OperatorSelectFieldFilter = ({ operatorId, operators, onChange }) => (
  <ResourceSelectFieldFilter
    labelId="field.operator"
    resourceId={operatorId}
    resources={operators}
    displayKey={listDesc}
    onChange={onChange}
  />
);

OperatorSelectFieldFilter.propTypes = {
  operatorId: PropTypes.number,
  operators: PropTypes.arrayOf(operatorDataShape),
  onChange: PropTypes.func.isRequired,
};

OperatorSelectFieldFilter.defaultProps = {
  operatorId: null,
  operators: null,
};

const mapStateToProps = (state) => ({
  operators: sortElements(state.operator.list.elements),
});

module.exports = connect(
  mapStateToProps,
  null,
)(OperatorSelectFieldFilter);



// WEBPACK FOOTER //
// ./routes/app/routes/simcards/assets/operators/OperatorSelectFieldFilter.js